import React from "react";
import { INotification } from "../common/interfaces/notifications.interface";

import { IAdminData, IUserAccount } from "../common/interfaces/user.interface";

interface UserContextInterface {
  user: IUserAccount | undefined;
  updateUser: (user: IUserAccount | undefined) => void;
  notifications: INotification[] | undefined;
  setNotifications: (notifications: INotification[]) => void;
  isNotificationsModalVisible: boolean;
  toggleNotificationsModal: (opened: boolean) => void;
  isXnft: boolean;
  setIsXnft: (isXnft: boolean) => void;
  isWhitelisted: boolean;
  toggleIsWhitelisted: (isWhitelisted: boolean) => void;
  adminData: IAdminData | undefined;
  setAdminData: (data: IAdminData | undefined) => void;
}

export const UserContext = React.createContext({} as UserContextInterface);
